import { render, staticRenderFns } from "./agv-article-like.vue?vue&type=template&id=0103f400&scoped=true&"
import script from "./agv-article-like.vue?vue&type=script&lang=js&"
export * from "./agv-article-like.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0103f400",
  null
  
)

export default component.exports